
let sdk =
  (function (module) {

    const EMYPT_APPID = 'Pease set appid use setAppId(aid) firstly'

    const EMPTY_PARAMS = 'Reqire param :%param%'

    const ERROR_INPUT_PARAMS = 'Error input :%param%'

    const phoneReg = /1[3|4|5|6|7|8|9][0-9]{9}/

    const emailReg = /\w+[-._0-9\w]+@[-._0-9\w]+\.[-._0-9\w+]/

    const userLoginUrl = 'https://grape.sosee.online/user/enroll'

    const userInfoUrl = 'https://grape.sosee.online/kuafu/carryData'

    const userTouristUrl = 'https://grape.sosee.online/user/tourist'

    const _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='

    Date.prototype.Format = function (fmt) {
      var o = {
        'M+': this.getMonth() + 1,
        'd+': this.getDate(),
        'h+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        'S': this.getMilliseconds()
      }

      if (/(y+)/.test(fmt)) { fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length)) }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
      }
      return fmt
    }

    let appid = '',
      lang = 'en',
      userPhone = '',
      stay_time = 0,
      last_time = 0,
      start_time = '',
      userEmail = ''

    let pages = []

    let isLogin = '0'

    let lastLen = 0,
      curLen = 0,
      curUrl = '',
      lastUrl = ''

    let userRole = '', _token = ''

    let browserType = BrowserType()

    let _device = 'miniapp'

    function _utf8_encode (string) {
      string = string.replace(/\r\n/g, '\n')
      var utftext = ''
      for (var n = 0; n < string.length; n++) {
        var c = string.charCodeAt(n)
        if (c < 128) {
          utftext += String.fromCharCode(c)
        } else if ((c > 127) && (c < 2048)) {
          utftext += String.fromCharCode((c >> 6) | 192)
          utftext += String.fromCharCode((c & 63) | 128)
        } else {
          utftext += String.fromCharCode((c >> 12) | 224)
          utftext += String.fromCharCode(((c >> 6) & 63) | 128)
          utftext += String.fromCharCode((c & 63) | 128)
        }
      }
      return utftext
    }

    // public method for encoding
    function encode (input) {
      var output = ''
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4
      var i = 0
      input = _utf8_encode(input)
      while (i < input.length) {
        chr1 = input.charCodeAt(i++)
        chr2 = input.charCodeAt(i++)
        chr3 = input.charCodeAt(i++)
        enc1 = chr1 >> 2
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
        enc4 = chr3 & 63
        if (isNaN(chr2)) {
          enc3 = enc4 = 64
        } else if (isNaN(chr3)) {
          enc4 = 64
        }
        output = output +
          _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
          _keyStr.charAt(enc3) + _keyStr.charAt(enc4)
      }
      return output
    }

    function _checkRequireParam (params) {
      for (let o in params) {
        if (params[o] === undefined) {
          throw Error(EMPTY_PARAMS.replace(/%param%/, o))
          return false
        }

        if (params[o + 'Check'] && !params[o + 'Check'].test(params[o]) && params[o]!='') {
          throw Error(ERROR_INPUT_PARAMS.replace(/%param%/, o))
          return false
        }
      }
      return true
    }

    function BrowserType () {
      try {
        if (wx != undefined) {
          return {
            shell: 'wechat'
          }
        }
      } catch (error) {

      }

      const ua = navigator.userAgent.toLowerCase()
      const testUa = regexp => regexp.test(ua)
      const testVs = regexp => (ua.match(regexp) + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
      let shell = 'none'
      let shellVs = 'unknow'
      if (testUa(/micromessenger/ig)) {
        shell = 'wechat' // 微信浏览器
        shellVs = testVs(/micromessenger\/[\d.]+/ig)
      } else if (testUa(/qqbrowser/ig)) {
        shell = 'qq' // QQ浏览器
        shellVs = testVs(/qqbrowser\/[\d.]+/ig)
      } else if (testUa(/ubrowser/ig)) {
        shell = 'uc' // UC浏览器
        shellVs = testVs(/ubrowser\/[\d.]+/ig)
      } else if (testUa(/2345explorer/ig)) {
        shell = '2345' // 2345浏览器
        shellVs = testVs(/2345explorer\/[\d.]+/ig)
      } else if (testUa(/metasr/ig)) {
        shell = 'sougou' // 搜狗浏览器
      } else if (testUa(/lbbrowser/ig)) {
        shell = 'liebao' // 猎豹浏览器
      } else if (testUa(/maxthon/ig)) {
        shell = 'maxthon' // 遨游浏览器
        shellVs = testVs(/maxthon\/[\d.]+/ig)
      } else if (testUa(/bidubrowser/ig)) {
        shell = 'baidu' // 百度浏览器
        shellVs = testVs(/bidubrowser [\d.]+/ig)
      }
      // 系统
      let system = 'unknown'
      if (testUa(/windows|win32|win64|wow32|wow64/ig)) {
        system = 'windows' // window系统
      } else if (testUa(/macintosh|macintel/ig)) {
        system = 'osx' // osx系统
      } else if (testUa(/x11/ig)) {
        system = 'linux' // linux系统
      } else if (testUa(/android|adr/ig)) {
        system = 'android' // android系统
      } else if (testUa(/ios|iphone|ipad|ipod|iwatch/ig)) {
        system = 'ios' // ios系统
      }

      let platform = 'unknow'
      if (system === 'windows' || system === 'osx' || system === 'linux') {
        platform = 'desktop' // 桌面端
      } else if (system === 'android' || system === 'ios' || testUa(/mobile/ig)) {
        platform = 'mobile' // 移动端
      }

      return Object.assign({
        platform, // desktop mobile
        shell,
        shellVs
      })
    }

    function ajax (data) {
      if (browserType.shell != 'wechat') {
        send_request()
      } else {
        send_vx_request()
      }
      function send_request () {
        let fd = new FormData()
        for (let o in data.data) {
          fd.append(o, data.data[o])
        }
        let settingData={
          method:data.type,
          headers:{...data.header,
          },
          mode: 'cors',
        }
        if(data.type=='POST'){
          settingData.body=fd
        }

        fetch(data.url,settingData).then(res=>{
          return res.json();

        }).then(res=>{
          if(data.success&&(data.success instanceof Function)){
            data.success(res)
          }
        })
      }

      function send_vx_request () {
        wx.request({
          url: data.url,
          method: data.type,
          data: data.data,
          header: {...data.header,
            'content-type': 'application/x-www-form-urlencoded'
          } || {},
          success: function (res) {
            if (res.data.code == '1300' || res.data.code == '1305') {
              _login()
            }
            if (data.success && (data.success instanceof Function)) {
              data.success(res.data)
            }
          }
        })
      }
    }

    let queueList =[]

    function checkList(){
      if(queueList.length==0)return;
      let cur = queueList[0];
      new Promise((resolve,reject) => {
        _sendMsg.apply(this,cur)
        resolve()
      }).then(res=>{
        queueList.shift()
      })
    }

    function setCheckInterval(){
      setInterval(function(){
        checkList()
      },3000)
    }

    setCheckInterval();

    function getUrl(){
      try{
        return location.href;
      }catch(e){
      }
    }

    function _sendMsg (eventType, actionTitle, actionValue, stayTime = 0, url) {
      if (!appid) {
        throw Error(EMYPT_APPID)
      }
      let args=arguments;

      function _sendS (success) {
        let data = {
          eventType: eventType,
          actionTitle: actionTitle,
          actionValue: actionValue,
          requestUrl: url || curUrl||getUrl() ,
          stayTime: (stayTime || 0) + '',
          actionTime: new Date().Format('yyyy-MM-dd hh:mm:ss'),
          carrierName: _device
        }
        let d = encode(JSON.stringify(data))
        console.log(data)
        if(getToken()==''){
          queueList.push(args)
          return;
        }
        ajax({
          url: userInfoUrl,
          type: 'POST',
          data: {'package':d},
          header: {
            AID: appid,
            token: getToken()
          }
        })
      }

      if (!userRole) {
        _login(null, _sendS)
      } else {
        _sendS()
      }
    }

    function setLoginStorage(){
      if(browserType.shell=='wechat'){
        wx.setStorageSync('isLogin'+appid, isLogin)
        wx.setStorageSync('userPhone'+appid, userPhone)
        wx.setStorageSync('userEmail'+appid, userEmail)
      }else{
        isLogin = localStorage.setItem('isLogin'+appid,isLogin)
        userPhone =  localStorage.setItem('userPhone'+appid,userPhone)
        userEmail =  localStorage.setItem('userEmail'+appid,userEmail)
      }
    }

    function getLoginStorage(){
      if(browserType.shell=='wechat'){
        isLogin = wx.getStorageSync('isLogin'+appid)
        userPhone = wx.getStorageSync('userPhone'+appid)
        userEmail = wx.getStorageSync('userEmail'+appid)
      }else{
        isLogin =  localStorage.getItem('isLogin'+appid)
        userPhone = localStorage.getItem('userPhone'+appid)
        userEmail = localStorage.getItem('userEmail'+appid)
      }

    }

    function _checkLogin () {
      return new Promise(resolve => {
        try {
          getLoginStorage()
        } catch (e) {
          return false
        }
        resolve()

      }).then(res=>{
        if (isLogin=='1') {
          return true
        }else{
          return false
        }
      })

    }

    let setToken=function (token){
      _token = token
    }

    let getToken=function (){
      return _token
    }

    function _login (obj, callback) {
      let url = userLoginUrl
      let type = 'POST'
      userRole = 'login'
      let _data = {}
      _checkLogin().then(res=>{
        if(!res&&!obj){
          url = userTouristUrl
          userRole = 'tourist'
          type = 'GET'
        }else if(obj){
          _data = obj
        }else{
          _data = {
            mobile_phone: userPhone,
            email: userEmail
          }
        }
        ajax({
          url: url,
          type: type,
          data: _data,
          header: {
            AID: appid,
          },
          success: function (res) {
            if (res.code == '2001') {
              setToken(res.data.token)
            }
            if (userRole == 'login') {
              isLogin = '1'
              userPhone = _data.mobile_phone
              userEmail = _data.email
              try {
                setLoginStorage()
              } catch (e) {}
            }
            if (callback && (callback instanceof Function)) callback(true)
          },
          error: function (res) {
            if (callback && (callback instanceof Function)) callback()
          }
        })
      })
    }

    function _setCurPage () {
      pages = getCurrentPages()

      curLen = pages.length - 1
      let curPage = pages[curLen]
      curUrl = curPage.route
      stay_time = 0
      start_time = new Date().getTime()

      if (lastLen && (curLen <= lastLen)) {
        _setLastLen(true)
      }

      lastUrl = curUrl
    }

    function _setLastLen (back) {
      let begin_time = back ? last_time : start_time

      stay_time = Math.ceil((new Date().getTime() - begin_time) / 1000)

      last_time = new Date().getTime()

      _sendMsg('time', 'stay', stay_time, stay_time, lastUrl)

      lastLen = curLen
    }

    let _s = function (aa) {
      appid = 'test'
    }

    _s.prototype.getAppid = function () {
      return appid
    }

    _s.prototype.setAppid = function (v) {
      appid = v
    }

    _s.prototype.getCarried = function () {
      return _device
    }

    _s.prototype.setCarried = function (v) {
      _device = v
    }

    _s.prototype.login = function (phone, email) {
      // let check = _checkRequireParam({
      //   phone,
      //   email,
      //   phoneCheck: phoneReg,
      //   emailCheck: emailReg
      // })
      // if (!check) return
      // _login({
      //   mobile_phone: phone,
      //   email
      // })
    }

    _s.prototype.click = function (title, value) {
      let check = _checkRequireParam({
        title, value
      })
      if (!check) return

      _sendMsg('click', title, value)
    }

    _s.prototype.time = function (title, value, stayTime) {
      let check = _checkRequireParam({
        title, value
      })
      if (!check) return
      _sendMsg('time', title, value, stayTime)
    }

    _s.prototype.load = function (title, value) {
      let check = _checkRequireParam({
        title, value
      })
      if (!check) return
      _sendMsg('load', title, value)
    }

    _s.prototype.Page = function (aa) {
      let opt = {}

      if (!aa && browserType.shell != 'wechat') {
        return this
      }

      for (let o in aa) {
        opt[o] = aa[o]
      }

      opt.onShow = function () {
        if (aa.onShow && (aa.onShow instanceof Function)) {
          aa.onShow.call(this)
        }
        _setCurPage()
      }

      opt.onHide = function async () {
        _setLastLen()
        if (aa.onHide && (aa.onHide instanceof Function)) {
          aa.onHide.call(this)
        }
      }

      Page(opt)
    }

    let instance = ''

    function getInstance () {
      if (instance) {
        return instance
      } else {
        return new _s()
      }
    }
    return getInstance()
  })(module)
export default sdk
